export const buttonStyles = {
  1: 'Primary',
  2: 'Green',
  3: 'Blue',
  4: 'Outline'
};

export const buttonTypes = {
  1: 'ButtonToClose',
  2: 'ButtonToGame',
  3: 'ButtonWithLink'
} as const;

export namespace models {
  export type ButttonStyle = 1 | 2 | 3 | 4;

  export type ButttonType = 1 | 2 | 3;

  export type ButttonTypeStr = (typeof buttonTypes)[keyof typeof buttonTypes];

  export type MessageVariant = 1 | 2 | 3 | 4 | 5; // 1 - PopUp, 2 - ToastUp,  3 - ToastDown, 4 - Push, 5 - Modal

  export type MessageDelayUnitID = 1 | 2; // 1 - seconds, 2 - minutes

  export interface RewardButtonParameters {
    LinkUrl?: string;
    GameID?: number;
    GameSystemName?: string;
  }

  export interface RewarButton {
    Order?: number;
    Text?: string;
    Style?: ButttonStyle;
    Type?: ButttonType;
    Parameters?: RewardButtonParameters;
  }

  export interface RewardMessage {
    PlatformToken?: string;
    Name?: string;
    Description?: string;
    Variant?: MessageVariant;
    Text?: string;
    Title?: string;
    UrlToImage?: string;
    RewardButtons?: RewarButton[];
    MessageDelay?: number;
    MessageDelayUnitID: MessageDelayUnitID;
  }
}

export const AVAILABLE_PLATFORMS = [
  'web',
  'mobile',
  'mobile_ios',
  'mobile_android'
] as const;
export type Platform = (typeof AVAILABLE_PLATFORMS)[number];
